import React, { useState, useEffect } from 'react';
import { getPatients } from '../api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Search, FileText, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Records() {
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const response = await getPatients(searchTerm);
        // Laravel devuelve {data: [...]}, Axios extrae el data, entonces accedemos a .data.data
        setPatients(Array.isArray(response.data?.data) ? response.data.data : (Array.isArray(response.data) ? response.data : []));
      } catch (error) {
        toast.error('Error al cargar pacientes');
      }
    };
    fetchPatients();
  }, [searchTerm]);

  return (
    <div className="p-6 md:p-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#2B2D42] font-['Manrope']">Expedientes</h1>
        <p className="text-[#5D5C61] mt-1">Accede a las historias clínicas y notas SOAP</p>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#8D99AE]" />
          <Input
            placeholder="Buscar paciente..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-11 bg-white border-slate-200"
            data-testid="records-search-input"
          />
        </div>
      </div>

      {/* Patients List */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {patients.map((patient) => (
          <Card
            key={patient.id}
            className="bg-white border-slate-100 hover:shadow-md hover:border-[#335C67]/20 transition-all cursor-pointer"
            onClick={() => navigate(`/expedientes/${patient.id}`)}
            data-testid={`record-card-${patient.id}`}
          >
            <CardHeader className="pb-2">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#335C67] flex items-center justify-center text-white font-semibold text-lg">
                  {(patient.first_name?.charAt(0) || patient.name?.charAt(0) || 'P') + (patient.paternal_surname?.charAt(0) || '')}
                </div>
                <div>
                  <CardTitle className="text-lg text-[#2B2D42]">{patient.full_name || patient.name}</CardTitle>
                  <p className="text-sm text-[#8D99AE]">{patient.whatsapp}</p>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-between pt-2 border-t border-slate-100">
                <span className="text-sm text-[#5D5C61]">Ver expediente</span>
                <FileText className="w-4 h-4 text-[#335C67]" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {patients.length === 0 && (
        <div className="text-center py-12">
          <User className="w-12 h-12 text-[#8D99AE] mx-auto mb-4" />
          <h3 className="text-lg font-medium text-[#2B2D42]">No hay pacientes</h3>
          <p className="text-[#5D5C61] mt-1">Registra pacientes para ver sus expedientes</p>
        </div>
      )}
    </div>
  );
}
